/* eslint-disable no-empty-pattern */
import mutations from "./mutations";
import getters from "./getters";
import Cookies from "js-cookie";
import { DataService, client } from "../../../config/dataService/dataService";
import { useMessage } from "../../../composables";
const { successMessage, errorMessage } = useMessage();

const state = () => ({
  login: Cookies.get("logedIn"),
  loading: false,
  error: null,
  statusCode: 0,
  companyInsights: [],
  admins: [],
  adminById: {},
  message: "",
  jobCandidatesLists: {},
  companyProfile: {},
  candidatesComp: {
    items: [],
    totalItems: 0,
  },
  candidatesJobList: {
    items: [],
    totalItems: 0,
  },
});

const actions = {
  async getCompanyInsights({ commit }) {
    try {
      const res = await DataService.get("/company/insights");

      if (Object.keys(res?.data)?.length) {
        commit("SET_COMPANY_INSIGHTS", []);
      }

      const items = [
        {
          name: "Company",
          year_1: `${res.data?.turnover_rate_year_1 || 0}%`,
          year_2:`${res.data?.turnover_rate_year_2 || 0}%`,
          year_3: `${res.data?.turnover_rate_year_3 || 0}%`,
        },
        {
          name: "Industry",
          year_1: `${res.data?.rank_in_industry_year_1 || 0}%`,
          year_2: `${res.data?.rank_in_industry_year_2 || 0}%`,
          year_3: `${res.data?.rank_in_industry_year_3 || 0}%`,
        },
        {
          name: "Sector",
          year_1: `${res.data?.rank_in_sector_year_1 || 0}%`,
          year_2: `${res.data?.rank_in_sector_year_2 || 0}%`,
          year_3: `${res.data?.rank_in_sector_year_3 || 0}%`,
        },
      ];

      commit("SET_COMPANY_INSIGHTS", items);

    } catch (error) {
      console.error(error);
    }
  },

  async registerCompany(context, data) {
    try {
      const formData = new FormData();
      formData.append("industry", data.industry);
      formData.append("logo", data.logo[0].originFileObj);
      formData.append("number_of_emplyees", data.number_of_emplyees);
      formData.append("year", data.year);
      formData.append("name", data.company_name);
      formData.append("sector", data.sector);
      formData.append("username", data.username);
      formData.append("password", data.password);
      formData.append("employee_range", data.employee_range);

      formData.append("services", JSON.stringify(data.service));
      let res = await client.post("public/company/register", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return res;
    } catch (err) {
      return err;
    }
  },

  async companyIsRegistrable(context, data) {
    try {
      let res = await DataService.post("/public/company/registerable", {
        username: data.username,
        password: data.password,
        role: "company",
      }).then((res) => res);
      return res.data;
    } catch (err) {
      return err;
    }
  },
  async getSingleCompany(contex, id) {
    let response = {};
    try {
      const res = await DataService.get(`admin/company/${id}`);
      response.company = { ...res.data };
    } catch (error) {
      response.company = null;
    }

    return response;
  },

  async getCompanyProfile({ commit }) {
    try {
      const res = await DataService.get(`company/profile`);
      commit("SET_COMPANY_PROFILE", res.data);
      return res;
    } catch (error) {
      return error;
    }
  },

  async getSingleJobPostCompany(context, id) {
    try {
      const res = await DataService.get(`company/job/${id}`);
      return res.data;
    } catch (error) {
      return error;
    }
  },

  async updateCompanyProfile({ dispatch }, data) {
    console.log(data);
    try {
      const formData = new FormData();

      formData.append("name", data.name);
      formData.append("logo", data.logo ? data.logo[0].originFileObj : "");
      formData.append("year", data.year);
      formData.append("contact_email", data.contact_email);
      formData.append("industry", data.industry);
      formData.append("sector", data.sector);
      formData.append("services", JSON.stringify(data.service));
      formData.append("employee_range", data.employee_range_id);
      formData.append("number_of_emplyees", data.number_of_emplyees);
      let res = await client.put(`/company/profile/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      // for (const key in data) {
      //   if (data[key]) {
      //     let form = key === "" ? data[key][0].originFileObj : data[key];

      //     formData.append(key, form);
      //   }
      // }
      // let res = await client.put(`/company/profile/`, formData, {
      //   headers: { "Content-Type": "multipart/form-data" },
      // });

      if (res.status === 200) {
        successMessage("Succesfully updated profile.");
        dispatch("getCompanyProfile");
      }
      return res;
    } catch (err) {
      errorMessage("Something went wrong");
      return err;
    }
  },

  //get list of job posts for this company
  async getCompJobList({ commit }, { page, itemPerPage, filters = {} }) {
    try {
      const res = await DataService.post("company/jobs/list", {
        filters: filters,
        pagination: {
          field: "id",
          ascending: true,
          page: filters ? 1 : page,
          items_per_page: itemPerPage,
        },
      });

      commit("SET_CANDIDATES_JOBS_LIST", res.data);
    } catch (error) {
      console.error(error);
    }
  },

  async companyCandidateById(context, id) {
    try {
      const res = await DataService.get(`company/candidate/jobs/list/${id}`);
      return res.data;
    } catch (error) {
      console.error(error);
    }
  },
  async getJobCandidateList({ commit }, { page, itemPerPage, filters = {} }) {
    try {
      const res = await DataService.post("candidate/jobs/list", {
        filters: filters,
        pagination: {
          field: "id",
          ascending: true,
          page: filters ? 1 : page,
          items_per_page: itemPerPage,
        },
      });

      commit("SET_JOB_CANDIDATES_LIST", res.data);
    } catch (error) {
      console.error(error);
    }
  },

  async getCandidatesForComp({ commit }, { page, itemPerPage, filters = {} }) {
    try {
      const res = await DataService.post("company/candidate/list", {
        filters: filters,
        pagination: {
          field: "id",
          ascending: true,
          page: filters ? 1 : page,
          items_per_page: itemPerPage,
        },
      });

      commit("SET_CANDIDATES_COMP", res.data);
    } catch (error) {
      console.error(error);
    }
  },

  // get list of candidates who applied for this company..
  async getCandidatesJobsList({ commit }, { page, itemPerPage, filters = {} }) {
    try {
      const res = await DataService.post("company/candidate/jobs/list", {
        filters: filters,
        pagination: {
          field: "id",
          ascending: true,
          page: filters ? 1 : page,
          items_per_page: itemPerPage,
        },
      });

      commit("SET_CANDIDATES_JOBS_LIST", res.data);
    } catch (error) {
      console.error(error);
    }
  },
  async syncCompany(context, data) {
    let response = {};
    try {
      let res = await DataService.post(`public/sync/company?name=${data}`);

      response.company = { ...res.data.data[0] };
    } catch (error) {
      console.error(error);
      response.company = null;
    }

    return response;
  },

  async syncRegisterCompany(context, data) {
    try {
      let res = await DataService.post(
        `public/sync/company/register/${data.id}`,
        {
          username: data.username,
          role: "company",
        }
      );
      return res;
    } catch (error) {
      console.error(error);
      return error;
    }
  },
  async resetCompanyUsername({ commit }, data) {
    try {
      let res = await DataService.post("auth/reset-username", {
        new_username: data,
      });
      if (res?.data.status === true) {
        commit("UPDATE_USERNAME", data);
      }
      return res;
    } catch (error) {
      console.error(error);
      return error;
    }
  },

  async deleteCompanyProfile() {
    try {
      let res = DataService.delete("company/profile");
      return res;
    } catch (error) {
      console.error(error);
      return error;
    }
  },
  async getCandidateJobApply({ page, itemPerPage, filters = {} }) {
    try {
      await DataService.post("admin/company/list", {
        filters: filters,
        pagination: {
          field: "id",
          ascending: true,
          page: filters ? 1 : page,
          items_per_page: itemPerPage,
        },
      });
    } catch (error) {
      console.error(error);
    }
  },

  async selectCandidates({}, applicants) {
    try {
      const res = await DataService.post("/company/check-applicants", {
        applicants,
      });
      successMessage("Candidates are selected successfully");
      return res.data;
    } catch (error) {
      console.error(error);
      errorMessage("Failed to selecte candidates");
    }
  },

  async deactivateAccountCompany() {
    try {
      let res = await DataService.delete(`company/profile`);
      return res;
    } catch (error) {
      console.error(error);
    }
  },

  async candidateJobList({ commit }) {
    try {
      const res = await DataService.get(`company/profile`);
      commit("SET_COMPANY_PROFILE", res.data);
      return res;
    } catch (error) {
      return error;
    }
  },
};

export default {
  namespaced: false,
  state,
  actions,
  mutations,
  getters,
};
